import { publicConfig } from "./config/constants";

const sharedLink = (route: string) => {
  return `${route.startsWith("https://") ? route : publicConfig.url + route}`;
};

const getTwitterShareLink = (text: string) => {
  return `https://twitter.com/intent/tweet?text=${sharedLink(text)}`;
};

const getFacebookShareLink = (route: string) => {
  return `https://www.facebook.com/sharer/sharer.php?u=${sharedLink(route)}`;
};

const getLinkedInShareLink = (route: string) => {
  return `https://www.linkedin.com/shareArticle?url=${sharedLink(route)}`;
};

const getMailShareLink = (route: string, title: string = "") => {
  return `mailto:?subject=${title}&body=${sharedLink(route)}`;
};

const getEndemicShareLink = (route: string) => {
  return `${publicConfig.url}/feed/global?text=${sharedLink(route)}`;
};

const openLinkInDialog = (url: string) => {
  return window.open(url, "Share from Endemic", "width=800,height=600");
};

export {
  getTwitterShareLink,
  getFacebookShareLink,
  getLinkedInShareLink,
  getMailShareLink,
  getEndemicShareLink,
  openLinkInDialog,
};
